export const CDN_URL = "https://nxtblog.ai/api/cdn/v1"